// extracted by mini-css-extract-plugin
module.exports = {"announcementBar":"styles_announcementBar__5tThT","fixedAnnouncementBar":"styles_fixedAnnouncementBar__J4PHv","ptext":"styles_ptext__CCh7U"};